// Endpoint for the unified product assistant; one REST POST per question, module-scoped.
import { baseApi } from '@/lib/api/baseApi';
import { processServerError } from '@/lib/api/listQuery';

// The assistant is mounted per certificate type: POST /{module}/assistant.
const ASSISTANT_PATH = (module) => `/${module}/assistant`;

export const chatbotApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    // POST a question, get { resolution, answer, interpretation, data, navigation }.
    askAssistant: build.mutation({
      query: ({ module, question }) => ({
        url: ASSISTANT_PATH(module),
        method: 'POST',
        body: { question },
      }),
      transformResponse: (res) => res?.output ?? res,
      transformErrorResponse: processServerError,
    }),
  }),
});

export const { useAskAssistantMutation } = chatbotApi;
